const cartRoute = `${window.Shopify?.routes?.root || '/'}cart.js`;

async function getCartSections() {
  const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
    .map((item) => item.dataset.sectionId)
    .filter(Boolean);

  if (!sectionIds.length) return {};

  const url = new URL(window.location.href);
  url.searchParams.set('sections', [...new Set(sectionIds)].join(','));
  url.searchParams.set('_', Date.now());

  return fetch(url.toString(), { cache: 'no-store' }).then((response) => response.json());
}

async function refreshCartFromQuizKit() {
  try {
    const [cart, sections] = await Promise.all([
      fetch(`${cartRoute}?t=${Date.now()}`, { cache: 'no-store' }).then((response) => response.json()),
      getCartSections(),
    ]);

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'quiz-kit',
          data: {
            source: 'quiz-kit',
            itemCount: cart.item_count,
            sections,
          },
        },
      })
    );

    requestAnimationFrame(() => {
      document.querySelector('cart-drawer-component')?.open();
    });
  } catch (error) {
    console.error('Quiz Kit cart refresh failed', error);
  }
}

document.addEventListener('quizKitAddToCartSuccess', refreshCartFromQuizKit);
